import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { OpportunityBoardType } from '@fitness-force/enum';
import { environment } from '@fitness-force/environments';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import { throwError, Observable, pipe } from "rxjs";
import { catchError, map, retry } from "rxjs/operators";
import type { CreateCallOutcomeRequest, CreateRecurringTaskByClientRequest, CreateRecurringTaskByOpportunityRequest, CreateTaskByClientRequest, CreateTaskByOpportunityRequest, CreateTourOutcomeRequest, UpdateTask, TASK_TYPE, CreateResponse, ClientTasks, DeleteTaskRequest, ReAssignTaskRequest } from '@fitness-force/models';
import { CONST_URL_SEGEMENTS } from "@fitness-force/constants";

@Injectable({
  providedIn: 'root'
})

export class TaskService {
  private http = inject(HttpClient);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  TaskGetAll(tenantId: number, allParams: Array<TASK_TYPE>): Observable<any> {

    let parsedParams = new HttpParams()
   if(allParams.length > 0){

    allParams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.paramName, p.paramValue);
    });
   }


   const url = environment.BASE_URL + CONST_URL_SEGEMENTS.TASK.GET_TASK.replace('{tenant_id}', tenantId.toString());
    return this.http.get(url,  {headers: this.httpOptions.headers , params: parsedParams}).pipe(
      map((res: any) => { return res; }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError());
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  TaskCreateServiceByClient(tenantId: number, createTaskByClientRequest: CreateTaskByClientRequest): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.TASK.POST_TASK_BY_CLIENT.replace('{tenant_id}', tenantId.toString());
    return this.http.post(url, createTaskByClientRequest, this.httpOptions).pipe(
      map((res: any) => { return res; }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError());
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  TaskCreateRecurringServiceByClient(tenantId: number, createRecurringTaskByClientRequest: CreateRecurringTaskByClientRequest): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.TASK.POST_RECURRING_TASK_BY_CLIENT.replace('{tenant_id}', tenantId.toString());
    return this.http.post(url, createRecurringTaskByClientRequest, this.httpOptions).pipe(
      map((res: any) => { return res; }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError());
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  TaskCreateServiceByOpportunity(tenantId: number, createTaskByOpportunityRequest: CreateTaskByOpportunityRequest): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.TASK.POST_TASK_BY_OPPORTUNITY.replace('{tenant_id}', tenantId.toString());
    return this.http.post(url, createTaskByOpportunityRequest, this.httpOptions).pipe(
      map((res: any) => { return res; }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError());
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  TaskCreateRecurringServiceByOpportunity(tenantId: number, createRecurringTaskByOpportunityRequest: CreateRecurringTaskByOpportunityRequest): Observable<Response> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.TASK.POST_RECURRING_TASK_BY_OPPORTUNITY.replace('{tenant_id}', tenantId.toString());
    return this.http.post(url, createRecurringTaskByOpportunityRequest, this.httpOptions).pipe(
      map((res: any) => { return res; }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError());
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  CreateLogCallOutcomeService(tenantId: number, taskId: number, createCallOutcomeRequest: CreateCallOutcomeRequest): Observable<Response> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.TASK.CREATE_CALL_OUTCOME.replace('{tenant_id}', tenantId.toString()), createCallOutcomeRequest, this.httpOptions).pipe(
      map((res: any) => { return res; }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError());
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  CreateLogTourOutcomeService(tenantId: number, taskId: number, createTourOutcomeRequest: CreateTourOutcomeRequest): Observable<Response> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.TASK.CREATE_TOUR_OUTCOME.replace('{tenant_id}', tenantId.toString()), createTourOutcomeRequest, this.httpOptions).pipe(
      map((res: any) => { return res; }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError());
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  UpdateTaskService(tenantId: number, taskId: number, updateTask: UpdateTask): Observable<CreateResponse> {
    return this.http.put(environment.BASE_URL + CONST_URL_SEGEMENTS.TASK.UPDATE_TASK
      .replace('{tenant_id}', tenantId.toString())
      .replace('{task_id}', taskId.toString()), updateTask, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
        , catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError());
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  GetTask(tenantId: number, taskId: number): Observable<any> {
    return this.http.get(environment.BASE_URL + CONST_URL_SEGEMENTS.TASK.GET_TASK_BY_ID
      .replace('{tenant_id}', tenantId.toString())
      .replace('{task_id}', taskId.toString()), this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
        , catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError());
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  GetAllTaskByClientId(clientId:number, allParams: Array<TASK_TYPE>): Observable<ClientTasks> {
  let parsedParams = new HttpParams()
   if(allParams.length > 0){
    allParams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.paramName, p.paramValue);
    });
   }

   const url = environment.BASE_URL + CONST_URL_SEGEMENTS.TASK.GET_TASK_BY_CLIENT_ID.replace('{client_id}', clientId.toString());
    return this.http.get(url,  {headers: this.httpOptions.headers , params: parsedParams}).pipe(
      map((res: any) => { return res; }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError());
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  DeleteTasks(tenantId: number, deleteTaskRequest: DeleteTaskRequest): Observable<any> {
    return this.http.delete(environment.BASE_URL + CONST_URL_SEGEMENTS.TASK.BULK_DELETE_TASKS
      .replace('{tenant_id}', tenantId.toString()),{headers: this.httpOptions.headers,body:deleteTaskRequest})
      .pipe(
        map((res: any) => {
          return res;
        })
        , catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError());
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  ReassignTasks(tenantId: number, reassignTaskRequest: ReAssignTaskRequest): Observable<any> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.TASK.BULK_REASSIGN_TASKS
      .replace('{tenant_id}', tenantId.toString()),reassignTaskRequest, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
        , catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError());
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  
}
